<template>
  <v-container fluid>
    <v-form>
      <v-text-field
        label="Filter Member Type"
        clearable
        v-model="memberType"
      />
      <v-checkbox
        label="Failed migrating member details"
        v-model="failMember"
      />
      <v-checkbox
        label="Failed migrating default user"
        v-model="failPerson"
      />
      <v-checkbox
        label="Failed migrating additional users"
        v-model="failPersons"
      />
      <v-text-field
        label="Search"
        clearable
        v-model="search"
      />
    </v-form>
    <v-data-table
      dense
      must-sort
      disable-filtering
      :headers="this.headers"
      :options.sync="options"
      :footer-props="footerProps"
      :server-items-length="this.list.count"
      :items="this.list.items"
      :loading="$apollo.queries.list.loading"
      item-key="_id"
    >
      <template v-slot:item="{ item }">
        <tr>
          <td>{{ item.memberNumber }}</td>
          <td>{{ item.propertyIdentificationCode }}</td>
          <td>{{ item.memberType }}</td>
          <td>{{ item.migrated }}</td>
          <td>{{ item.defaultPersonMigrated }}</td>
          <td>{{ item.additionalPeopleMigrated }}</td>
          <td>{{ item.error }}</td>
        </tr>
      </template>

      <template v-slot:footer.prepend>
        <v-btn
          icon
          :loading="$apollo.queries.list.loading"
          :disabled="$apollo.queries.list.loading"
          @click="$apollo.queries.list.refresh()"
        >
          <v-icon>refresh</v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import gql from 'graphql-tag'

import gqlSortMixin from '../mixins/gql-sort-mixin'

export default {
  name: 'AdminInfoSysMemberListView.vue',

  mixins: [
    gqlSortMixin
  ],

  data: () => ({
    headers: [
      {
        text: 'Member Number',
        value: 'memberNumber'
      },
      {
        text: 'PIC',
        value: 'propertyIdentificationCode'
      },
      {
        text: 'Member Type',
        value: 'memberType'
      },
      {
        text: 'Migrated',
        value: 'migrated'
      },
      {
        text: 'Default person migrated',
        value: 'defaultPersonMigrated'
      },
      {
        text: 'Additional people migrated',
        value: 'additionalPeopleMigrated'
      },
      {
        text: 'Error',
        value: 'error'
      }
    ],
    options: {
      multiSort: false,
      mustSort: true,
      sortDesc: [false],
      sortBy: ['memberNumber'],
      page: 1,
      itemsPerPage: 25
    },
    footerProps: {
      'items-per-page-options': [10, 25, 50, 100, 200, 500]
    },
    list: {
      count: 0,
      items: []
    },
    search: '',
    memberType: null,
    failMember: true,
    failPerson: true,
    failPersons: true
  }),

  apollo: {
    list: {
      query: gql`query InfoSysMembersList ($filter: FilterFindManyInfoSysMemberInput, $page: Int!, $perPage: Int!, $sort: SortFindManyInfoSysMemberInput!) {
        list: infoSysMemberManyPagination(filter: $filter, page: $page, perPage: $perPage, sort: $sort) {
          count
          items {
            memberNumber
            propertyIdentificationCode
            memberType
            error
            migrated
            defaultPersonMigrated
            additionalPeopleMigrated
          }
        }
      }`,
      variables () {
        const filter = {
          migrated: !this.failMember,
          defaultPersonMigrated: !this.failPerson,
          additionalPeopleMigrated: !this.failPersons
        }
        if (this.search) {
          filter.OR = [
            { memberNumber: this.search },
            { propertyIdentificationCode: this.search }
          ]
        }
        if (this.memberType) {
          filter.memberType = this.memberType
        }

        return {
          filter,
          page: this.options.page,
          perPage: this.options.itemsPerPage,
          sort: this.gqlSort(this.options)
        }
      },
      debounce: 250,
      error (e) { this.$emit('error', e) }
    }
  }
}
</script>
